module.exports = global["surveylab_survey_comment"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./comment.ts");